import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/public/PublicLayout";
import AdminLayout from "@/components/admin/AdminLayout";

import Home from "@/pages/public/Home";
import InfoBawaslu from "@/pages/public/InfoBawaslu";
import NewsDetail from "@/pages/public/NewsDetail";
import SuaraMasyarakat from "@/pages/public/SuaraMasyarakat";
import StatusAspirasi from "@/pages/public/StatusAspirasi";
import MediaCenter from "@/pages/public/MediaCenter";
import TanyaBawaslu from "@/pages/public/TanyaBawaslu";
import BawasluTerdekat from "@/pages/public/BawasluTerdekat";
import OfficeDetail from "@/pages/public/OfficeDetail";
import Edukasi from "@/pages/public/Edukasi";
import EdukasiDetail from "@/pages/public/EdukasiDetail";
import Kuis from "@/pages/public/Kuis";
import Agenda from "@/pages/public/Agenda";
import Tentang from "@/pages/public/Tentang";

import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import NewsAdmin from "@/pages/admin/NewsAdmin";
import NewsForm from "@/pages/admin/NewsForm";
import AgendasAdmin from "@/pages/admin/AgendasAdmin";
import AspirationsAdmin from "@/pages/admin/AspirationsAdmin";
import MediaAdmin from "@/pages/admin/MediaAdmin";
import FaqAdmin from "@/pages/admin/FaqAdmin";
import ChatLogsAdmin from "@/pages/admin/ChatLogsAdmin";
import EducationAdmin from "@/pages/admin/EducationAdmin";
import OfficesAdmin from "@/pages/admin/OfficesAdmin";
import UsersAdmin from "@/pages/admin/UsersAdmin";
import AnalyticsAdmin from "@/pages/admin/AnalyticsAdmin";
import AuditLogAdmin from "@/pages/admin/AuditLogAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";

function App() {
  useEffect(() => { document.title = "HARMONI BAWASLU — Satu Pintu Komunikasi Publik"; }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/info" element={<InfoBawaslu />} />
            <Route path="/info/:slug" element={<NewsDetail />} />
            <Route path="/suara-masyarakat" element={<SuaraMasyarakat />} />
            <Route path="/suara-masyarakat/status" element={<StatusAspirasi />} />
            <Route path="/media-center" element={<MediaCenter />} />
            <Route path="/media-center/press-release" element={<MediaCenter defaultTab="press" />} />
            <Route path="/media-center/dokumentasi" element={<MediaCenter defaultTab="foto" />} />
            <Route path="/tanya-bawaslu" element={<TanyaBawaslu />} />
            <Route path="/bawaslu-terdekat" element={<BawasluTerdekat />} />
            <Route path="/bawaslu-terdekat/:id" element={<OfficeDetail />} />
            <Route path="/edukasi" element={<Edukasi />} />
            <Route path="/edukasi/:id" element={<EdukasiDetail />} />
            <Route path="/kuis" element={<Kuis />} />
            <Route path="/agenda" element={<Agenda />} />
            <Route path="/tentang" element={<Tentang />} />
          </Route>

          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="news" element={<NewsAdmin />} />
            <Route path="news/create" element={<NewsForm />} />
            <Route path="news/:id" element={<NewsForm />} />
            <Route path="agendas" element={<AgendasAdmin />} />
            <Route path="aspirations" element={<AspirationsAdmin />} />
            <Route path="media" element={<MediaAdmin />} />
            <Route path="press-release" element={<MediaAdmin />} />
            <Route path="faq" element={<FaqAdmin />} />
            <Route path="chat-logs" element={<ChatLogsAdmin />} />
            <Route path="education" element={<EducationAdmin />} />
            <Route path="offices" element={<OfficesAdmin />} />
            <Route path="users" element={<UsersAdmin />} />
            <Route path="analytics" element={<AnalyticsAdmin />} />
            <Route path="audit-log" element={<AuditLogAdmin />} />
            <Route path="settings" element={<SettingsAdmin />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
